import { createSlice } from '@reduxjs/toolkit';
import { SORT, SORT_TYPE } from 'lib/constant/index';

const initialState = {
  sort: SORT.DATE,
  sortType: SORT_TYPE.DESC,
  search: '',
  contractRegisterForm: {
    contract: {
      company: '',
      code: '',
      termStartDate: '',
      termEndDate: '',
      name: '',
      tel: '',
      detail: '',
    },
    store: [] /*[{name: String, address: String, detailAddress: String}]*/,
    user: {
      id: '',
      userId: '',
      password: '',
      passwordConfirm: '',
      name: '',
      team: '',
      position: '',
      tel: '',
      email: '',
    },
    originalContractId: null,
    updateStore: [],
    insertStore: [],
  },
};

const contractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    changeProp: (state, { payload: { key, value } }) => {
      state[key] = value;
    },
    initialize: () => initialState,
    sort: (state, { payload: sortType }) => {
      state.sort = sortType;
      if (state.sortType === SORT_TYPE.DESC) {
        state.sortType = SORT_TYPE.ASC;
      } else {
        state.sortType = SORT_TYPE.DESC;
      }
    },
    changeRegisterForm: (state, { payload: { form, key, value } }) => {
      if (key) {
        state.contractRegisterForm[form][key] = value;
      } else {
        state.contractRegisterForm[form] = value;
      }
    },
    initializeRegisterForm: state => {
      state.contractRegisterForm = initialState.contractRegisterForm;
    },
    setOriginalContract: (
      { contractRegisterForm },
      { payload: { contract, master } },
    ) => {
      contractRegisterForm.contract = contract;
      contractRegisterForm.updateStore = contract.store;
      contractRegisterForm.user = master;
      contractRegisterForm.user.password = '';
      contractRegisterForm.user.passwordConfirm = '';
      contractRegisterForm.originalContractId = contract.id;
    },
  },
});

export const {
  changeProp,
  initialize,
  sort,
  changeRegisterForm,
  initializeRegisterForm,
  setOriginalContract,
} = contractSlice.actions;

export default contractSlice.reducer;
